<div class="fullcontainer pr-3">
  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Report - Load count</h1>
    </div>

    <div class='row'>
      <div class='col-md-4'>
        <label>Start Date</label>
        <input type='date' [(ngModel)]="this.searchFilters.startDate" class='form-control' />
      </div>
      <div class='col-md-4'>
        <label>End Date</label>
        <input type='date' class='form-control' [(ngModel)]="this.searchFilters.endDate" />
      </div>
      <div class='col-md-4'>
        <label>Parent Job ID</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.parentJobId" />
      </div>
      <div class='col-md-4'>
        <label>Job Number</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.id" />
      </div>
      <div class='col-md-4'>
        <label>Customer</label>
        <ng-select [(ngModel)]="this.searchFilters.customer" (change)='this.searchFilters.customer = $event;'>
          @for (item of this.accounts; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Site</label>
        <ng-select [(ngModel)]="this.searchFilters.site" (change)='this.searchFilters.site = $event;'>
          @for (item of this.sites; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Vehicle</label>
        <ng-select [(ngModel)]="this.searchFilters.vehicle" (change)='this.searchFilters.vehicle = $event;'>
          @for (item of this.vehicles; track item) {
            <ng-option [value]='item.registration'>{{ item.registration }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Driver</label>
        <ng-select [(ngModel)]="this.searchFilters.driver" (change)='this.searchFilters.driver = +$event;'>
          @for (item of this.drivers; track item) {
            <ng-option [value]='item.id'>{{ item.firstName }} {{ item.lastName }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Tip Site</label>
        <ng-select [(ngModel)]="this.searchFilters.tipSite" (change)='this.searchFilters.tipSite = $event;'>
          @for (item of this.tips; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Order Ref</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.orderRef"/>
      </div>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' (click)='this.loadReport()'>Run Report</button>
    <hr />
    <button class='btn btn-secondary' (click)='exportToCSV()'>Export to CSV</button>
  </div>

  <div class='sheet'>
    @if (this.jobs.length > 0) {
      <div class='titleContainer'>
        <h1 class='header'>Results</h1>
        @if (this.selectedJobs.length > 0) {
          <p style='font-size:2rem'>
            <strong>Total Selected: {{ this.getSelectedDetails().total }} Total Qty: {{ this.getSelectedDetails().qty }} Total Price: {{this.getSelectedDetails().price }}</strong>
          </p>
        }
        <h3>TOTAL LOAD COUNT: {{ getTotalLoadCount() }}</h3>
        <table class='table'>
          <thead>
            <th></th>
            <th>Job ID</th>
            <th>Order Ref</th>
            <th>Customer</th>
            <th>Site</th>
            <th>Tip Site</th>
            <th>Number of Loads</th>
            <th>Date</th>
            <th>Driver</th>
            <th>Vehicle</th>
            <th></th>
          </thead>
          <tbody>
            @for (job of this.jobs; track job) {
              <tr>
                <td><input type='checkbox' (change)='this.onSelectJob(job)'/></td>
                <td>{{ job.id }}</td>
                <td>{{ job.order.id }}</td>
                <td>{{ job.order.account.name }}</td>
                <td>{{ job.order.site.name }}</td>
                <td>{{ job.order.tipSite.name }}</td>
                <td>{{ job.qty }}</td>
                <td>{{ job.date }}</td>
                <td>{{ job.jobAssignment.driver ? job.jobAssignment.driver.firstName : '' }} {{ job.jobAssignment.driver ? job.jobAssignment.driver.lastName : '' }} </td>
                <td>{{ job.jobAssignment.vehicle ? job.jobAssignment.vehicle.registration : 'N/A' }}</td>
                <td><button class='btn btn-warning' [routerLink]='"/orders/edit/" + job.order.id'>View Order</button><button class='btn btn-warning' [routerLink]='"/job-signoff/land/view/" + job.id'>View job</button>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
